import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useOutletDocumentDetails } from "./Outlet.hook";

export const AddEditStoreOutlet = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editOutlet,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useOutletDocumentDetails(query.get("editId") || "");

  const {
    data: editOutletById,
    isLoading: isLoadingProducts,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
      field_stores_name: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload?.field_stores_name)
        : decodeHTML(editOutlet?.field_stores_name || ""),

      field_stores_name_ms: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload?.field_stores_name_ms)
        : decodeHTML(editOutlet?.field_stores_name_ms || ""),

      field_stores_name_zh: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload?.field_stores_name_zh)
        : decodeHTML(editOutlet?.field_stores_name_zh || ""),

      // field_time_icon: editOutletById?.payload
      //   ? [
      //       {
      //         uid: "-1",
      //         name: "brandImage.png",
      //         status: "done",
      //         url: editOutletById?.payload?.field_time_icon,
      //       },
      //     ]
      //   : [
      //       {
      //         uid: "-1",
      //         name: "brandImage.png",
      //         status: "done",
      //         url: editOutlet?.field_time_icon,
      //       },
      //     ],

      field_store_main_image: editOutletById?.payload
        ? [
            {
              uid: "-1",
              name: "field_store_main_image.png",
              status: "done",
              url: editOutletById?.payload?.field_store_main_image,
            },
          ]
        : editOutlet?.field_store_main_image
          ? [
              {
                uid: "-1",
                name: "field_store_main_image.png",
                status: "done",
                url: editOutlet?.field_store_main_image,
              },
            ]
          : "",

      field_store_description_image: editOutletById?.payload
        ? [
            {
              uid: "-1",
              name: "field_store_description_image.png",
              status: "done",
              url: editOutletById?.payload?.field_store_description_image,
            },
          ]
        : editOutlet?.field_store_description_image
          ? [
              {
                uid: "-1",
                name: "field_store_description_image.png",
                status: "done",
                url: editOutlet?.field_store_description_image,
              },
            ]
          : "",

      field_store_time: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload?.field_store_time)
        : decodeHTML(editOutlet?.field_store_time || ""),

      field_store_description: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload?.field_store_description)
        : decodeHTML(editOutlet?.field_store_description || ""),

      published: editOutletById?.payload
        ? decodeHTML(editOutletById?.payload.published || false)
        : decodeHTML(editOutlet?.published || false),
    },

    fields: fields.outlet,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["field_store_description_image", "field_store_main_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Store Location",
      subModule: "outlet",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editOutlet?.id || editOutletById?.payload?.id }),
        ...data,
      },
      status: status,
    };

    // Log the complete payload
    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Outlet`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingProducts}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/get-location-map-stores-crud-data/${editOutlet?.id || editOutletById?.payload?.id}` : `${eramanHost}/api/create-location-map-stores-crud-data`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
